<template>
  <div class="has-helper" :class="{ 'form-group': !stacked, 'w-100': stacked }">
    <div :class="{ 'col-lg-4': !stacked }" v-if="label">
      <label class="control-label">{{ label }}:</label>
      <p class="help-block" v-if="helper">
        {{ helper }}
      </p>
    </div>
    <div :class="{ 'col-lg-8': !stacked && label }">
      <datepicker
        :name="name || 'date'"
        format="dd/MM/yyyy"
        :value="value"
        :disabled="disabled"
        v-on:selected="emitChange"
        input-class="form-control"
        placeholder="dd/mm/yyyy"
      ></datepicker>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    label: {
      type: String
    },
    helper: {
      type: String
    },
    name: {
      type: String
    },
    disabled: {
      type: Object,
      default() {
        return {};
      }
    },
    stacked: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },

  methods: {
    emitChange(value) {
      return this.$emit('input', value);
    }
  }
};
</script>
